import { type ReactElement } from 'react';

export type StatusIconKind = 'mail' | 'check' | 'link' | 'lock';

const TONE: Record<StatusIconKind, string> = {
  mail: 'bg-infoSoft text-info',
  check: 'bg-goodSoft text-good',
  link: 'bg-warnSoft text-warn',
  lock: 'bg-accentSoft text-accent',
};

const PATH: Record<StatusIconKind, ReactElement> = {
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </>
  ),
  check: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  lock: (
    <>
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </>
  ),
  link: (
    <>
      <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
      <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
    </>
  ),
};

/**
 * A round, calm status illustration for the signed-out screens. Decorative only (`aria-hidden`): the title and the text
 * next to it always say the same thing in words, so nothing depends on seeing the picture or its colour.
 */
export function StatusIcon({ kind }: { readonly kind: StatusIconKind }): ReactElement {
  return (
    <span
      className={`flex h-14 w-14 items-center justify-center rounded-full ${TONE[kind]}`}
      aria-hidden="true"
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {PATH[kind]}
      </svg>
    </span>
  );
}
